/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.Accountsync {
    'use strict';

    class TooltipController {
        private tooltipViewPath: string;
        private tooltipMessage: string;

        constructor() { }
    }

    class TooltipComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/accountsync/components/tooltip/tooltip.template.html';
        controller = TooltipController;
        controllerAs = 'model';
        bindings: any = {
            tooltipViewPath: '@?',
            tooltipMessage: '@?'
        };
    }

    angular.module('meevo.plugins.accountsync')
        .component('accountsyncTooltipComponent', new TooltipComponent());
}

